<script>
// import axios from 'axios'
// import qs from 'qs'

/** Customer 와 Admin은 페이지 구성을 공유함 */
import RegiParcelComp from "@/components/common/RegiParcelComp.vue"

export default {
  name: "Order-registration",
  components: {
    RegiParcelComp,
  },
  data() {
    return {
      navCurrent  : 'Order-registration',
      description : {
        title : 'AUS -> KOR',
        desc  : '호주에서 한국으로 보내는 배송요청을 접수하세요.',
      },
      partnerId   : '', // 파트너 ID
      partnerName : '', // 파트너 이름
      memberId    : '',
    }
  },
  methods: {

  },
  mounted() {
    // 페이지가 로드될 때 파트너 ID를 가져온다
    this.partnerId    = this.$route.query.partnerId || '1'
    this.partnerName  = this.$route.query.partnerName || 'AONE'
    this.memberId     = this.$route.query.memberId || ''
  },
}
</script>

<template>
  <main id="site-container">
    <div class="section">
      <div class="container doc-page">
        <div class="row items-center">
          <div class="col">
            <h4 class="page-title text-center">
              AUS -> KOR
            </h4>
            <p class="partner">방문하신 파트너사는 [<span>{{partnerName}}</span>] 입니다</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container doc-page q-pb-xl">
      <div class="row q-mb-lg">
        <div class="col">
          <!-- <OrderRegCustomer /> -->
          <RegiParcelComp
            :memberId="memberId"
            :partnerId="partnerId"  />
        </div>
      </div>
    </div>
  </main>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-title {
  font-weight: 600;
  font-size: 30px;

  margin : 0;
  
  color: black;

  @media (max-width: 600px) {
    font-size: 24px;
  }
}

.partner {
  font-size: 16px;
  text-align: center;
  margin-top: 0.5rem;
  margin-bottom: 0;
  color: #666;

  span {
    font-weight: 600;
    color: #000;
  }

  @media (max-width: 600px) {
    font-size: 14px;
  }
}
</style>
